import OneRepMaxChartDataContext from "../contexts/OneRepMaxChartDataContext";
import type { LineData } from "components/charting/types/Chart.types";
import useDefinedContext from "hooks/useDefinedContext";

function useOneRepMaxChartData(): LineData[] {
  return useDefinedContext(OneRepMaxChartDataContext);
}

export default useOneRepMaxChartData;
